exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".advising-expanstion-panel {\n  border: 1px solid #ccc;\n  min-height: auto;\n  max-height: unset;\n  overflow: auto;\n  scrollbar-width: thin;\n}\n", ""]);

// exports
